import React, { useEffect, useState } from 'react';
import { Menu, X } from 'lucide-react';
import { motion, AnimatePresence } from 'framer-motion';
import { Logo } from './Logo';
export function Navbar() {
  const [isScrolled, setIsScrolled] = useState(false);
  const [isMobileMenuOpen, setIsMobileMenuOpen] = useState(false);
  useEffect(() => {
    const handleScroll = () => {
      setIsScrolled(window.scrollY > 10);
    };
    window.addEventListener('scroll', handleScroll, {
      passive: true
    });
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);
  const navLinks = [{
    name: 'El problema',
    href: '#problema'
  }, {
    name: 'La solución',
    href: '#solucion'
  }, {
    name: 'Cómo funciona',
    href: '#como-funciona'
  }, {
    name: 'Precio',
    href: '#precio'
  }];
  const scrollToSection = (href: string) => {
    setIsMobileMenuOpen(false);
    const element = document.querySelector(href);
    if (element) {
      element.scrollIntoView({
        behavior: 'smooth'
      });
    }
  };
  return <header className={`fixed top-0 left-0 right-0 z-40 transition-all duration-300 ${isScrolled ? 'bg-white/90 backdrop-blur-md shadow-sm py-3' : 'bg-white py-5'}`} data-id="element-170">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-171">
        <div className="flex justify-between items-center" data-id="element-172">
          {/* Logo */}
          <div className="flex-shrink-0 cursor-pointer" onClick={() => window.scrollTo({
          top: 0,
          behavior: 'smooth'
        })} data-id="element-173">
            <Logo size="md" variant="dark" data-id="element-174" />
          </div>

          {/* Desktop Navigation */}
          <nav className="hidden md:flex items-center space-x-8" data-id="element-175">
            {navLinks.map(link => <button key={link.name} onClick={() => scrollToSection(link.href)} className="text-sm font-medium text-gray-600 hover:text-blue-600 transition-colors" data-id="element-176">
                {link.name}
              </button>)}
            <button onClick={() => scrollToSection('#contacto')} className="text-sm font-medium bg-blue-600 text-white px-4 py-2 rounded-md hover:bg-blue-700 transition-colors" data-id="element-177">
              Contacto
            </button>
          </nav>

          {/* Mobile Menu Button */}
          <div className="md:hidden" data-id="element-178">
            <button onClick={() => setIsMobileMenuOpen(!isMobileMenuOpen)} className="text-gray-600 hover:text-gray-900 focus:outline-none" data-id="element-179">
              {isMobileMenuOpen ? <X className="h-6 w-6" data-id="element-180" /> : <Menu className="h-6 w-6" data-id="element-181" />}
            </button>
          </div>
        </div>
      </div>

      {/* Mobile Navigation */}
      <AnimatePresence data-id="element-182">
        {isMobileMenuOpen && <motion.div initial={{
        opacity: 0,
        height: 0
      }} animate={{
        opacity: 1,
        height: 'auto'
      }} exit={{
        opacity: 0,
        height: 0
      }} className="md:hidden bg-white border-b border-gray-100 overflow-hidden" data-id="element-183">
            <div className="px-4 pt-2 pb-6 space-y-1 shadow-lg" data-id="element-184">
              {navLinks.map(link => <button key={link.name} onClick={() => scrollToSection(link.href)} className="block w-full text-left px-3 py-3 text-base font-medium text-gray-700 hover:text-blue-600 hover:bg-gray-50 rounded-md" data-id="element-185">
                  {link.name}
                </button>)}
              <button onClick={() => scrollToSection('#contacto')} className="block w-full text-center mt-4 px-3 py-3 text-base font-medium bg-blue-600 text-white rounded-md hover:bg-blue-700" data-id="element-186">
                Contacto
              </button>
            </div>
          </motion.div>}
      </AnimatePresence>
    </header>;
}